import { connect } from 'react-redux';
import { getCurrentUserId } from '../../../../../publicSession/selectors';
var _ref;
const mapStateToProps = (state, ownProps)=>{
    var _ownProps_folder_thumb;
    return {
        hasBlurredCoverTooltip: (_ref = ((_ownProps_folder_thumb = ownProps.folder.thumb) === null || _ownProps_folder_thumb === void 0 ? void 0 : _ownProps_folder_thumb.premiumFolderData) && ownProps.folder.owner && getCurrentUserId(state) === ownProps.folder.owner.userId) !== null && _ref !== void 0 ? _ref : false
    };
};
export default connect(mapStateToProps);
